(function (angular) {
  "use strict";

  angular.module("alk.analytics", []);

  angular
    .module("alk.analytics")
    .directive("alkGoogleAnalytics", [function () {
      return {
        retrict: "A",
        scope: {
          alkGoogleAnalytics: "@"
        },
        controllerAs: "vm",
        bindToController: true,
        controller: ["$rootScope", "$scope", "$location", "$window", "$attrs", function($rootScope, $scope, $location, $window, $attrs) {
          var vm = this;
          //fix for JIRA task SWFV-334
          (function (i, s, o, g, r, a, m) {
            i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
              (i[r].q = i[r].q || []).push(arguments)
            }, i[r].l = 1 * new Date(); a = s.createElement(o),
            m = s.getElementsByTagName('head')[0]; a.async = 1; a.src = g; m.insertBefore(a, m.firstChild);
          })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');

          $window.ga('create', vm.alkGoogleAnalytics || $attrs.alkGoogleAnalytics, 'auto');

          var first = true;

          var track = function () {
            if (first) {
              // avoid duplicate call to tracking page view on initial page load
              first = false;
              return;
            }

            $window.ga("send", "pageview", { "page": $location.path() });
          };

          //fire on each route change
          var cleanupViewContentLoaded = $rootScope.$on("$viewContentLoaded", track);

          vm.getGoogleAnalytics = function () { return $window.ga; };

          $scope.$on("$destroy", function () {
            cleanupViewContentLoaded();
          });
        }]
      }
    }]);

  angular
    .module("alk.analytics")
		.directive("alkAnalytics", [function () {
		  return {
		    require: ["^alkGoogleAnalytics"],
		    restrict: "A",
		    link: function (scope, element, attrs, alkGoogleAnalytics) {
		      var myGa = alkGoogleAnalytics[0].getGoogleAnalytics();

		      var bindEvent = attrs.analyticsOn || "click";
		      var commands;

		      if (attrs.alkAnalytics) {
		        commands = scope.$eval(attrs.alkAnalytics);
		      } else {
		        commands = [element[0].tagName];
		        if (element.attr("id")) commands.push(element.attr("id"));
		      }

		      var gaCommands = ["send", "event"].concat(commands);

		      element.bind(bindEvent, function () {
		        myGa.apply(this, gaCommands);
		      });
		    }
		  };
		}]);

})(window.angular);



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-analytics/alkAnalytics.js